import React from 'react';
import _ from 'lodash'
import { Box, Card, CardContent, Typography, TextField, Grid, Button, Link } from '@mui/material'

import { useRouteMatch } from 'react-router'
import { useHistory, Redirect } from "react-router-dom"
import { Container, Form, Spinner } from 'react-bootstrap'
import { useStyles as useStylesBase } from '../../constants/useStyles';
import ButtonLoading from '../../components/ButtonLoading'
import TextFieldValidate from '../../components/TextFieldValidate'

import config from '../../constants/config';
import { AxiosInstance } from '../../utils/RequestMethods'
import { getQueryStringParams, naviagte } from '../../utils/utilsT'

export type IFormVerifyResetPasswordProps = {
  email: string
}


const FormVerifyResetPassword: React.FC<IFormVerifyResetPasswordProps> = (props) => {
  const classesBase = useStylesBase()
  const [validated, setValidated] = React.useState(false);
  const [completedRequest, setCompletedRequest] = React.useState(false);
  const [codePin, setCodePin] = React.useState("");

  const [successValidateCode, setSuccessValidateCode] = React.useState(false);
  const [isFetching, setIsFetching] = React.useState(false)
  const [attempts, setAttempts] = React.useState(0)
  const [finishAttempts, setFinishAttempts] = React.useState(false);
  const match = useRouteMatch()
  const history = useHistory()
  const [statusValidateCode, setStatusValidateCode] = React.useState<'none' | 'inValid' | 'valid'>("none");

  React.useEffect(() => {

  }, []);




  const submit = async (e): Promise<string> => {
    e.preventDefault();
    setValidated(true)
    if (codePin == "") {
      throw new Error("Make sure to input correct email.")
    }
    if (attempts > 5) {
      setFinishAttempts(true)
      throw new Error("Exceeded maximum number for attempts. Try again later.")
    }
    setAttempts(attempts + 1)
    try {

      let params = {
        email: props.email,
        code_pin: codePin,
        platform: "web",
      }
      return await AxiosInstance.post(`${config.url.token}/password/validate`, params).then((res) => {
        if (res && res.data) {
          let msg = res.data.message ? res.data.message : "";
          // let data: UserT = res.data;
          setCompletedRequest(true)
        }
        return "Security code verified."
      })

    } catch (error) {
      throw new Error(error)
    }
  }
  if (completedRequest) {
    return <Redirect to={`/change-password?email=${props.email}&code=${codePin}`} />
  }
  if (statusValidateCode == "inValid" || finishAttempts == true) {
    return <Redirect to='/login' />
  }



  return (
    <Container style={{ marginTop: "10vh" }}>
      <Box className=" d-flex  justify-content-center mb-2">
        <Card className="  col-md-8">
          <CardContent>

            <Form validated={validated} noValidate onSubmit={submit} style={{ padding: "20px" }}>
              <Typography variant='h5' className='mb-3' style={{}} >Enter security code</Typography>
              <Grid container spacing={3} className="mt-4">
                <Grid item xs={12}>
                  <Typography>Please check your email for a message with your code. Your code is 6 numbers long.</Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextFieldValidate

                    fullWidth
                    required
                    variant="standard"
                    autoComplete={'off'}
                    name="code"
                    label="Code"
                    placeholder='Enter code'
                    InputProps={{
                      // disableUnderline: true,
                    }}
                    value={`${codePin}`}
                    onChange={(event: any) => {
                      let value = event.target.value
                      setCodePin(value)
                    }}
                    validated={validated}
                    onValidateError={(value) => {
                      if (value == "") {
                        return "Code is required."
                      }
                      return ""
                    }}
                  />

                </Grid>
                <Grid item xs={12}>

                  <ButtonLoading
                    customButton={Button}
                    customButtonProps={{
                      fullWidth: true,
                      variant: "contained",
                      color: "success",
                      size: "large"
                    }}

                    type="submit"
                    onClickFetching={submit}>
                    <Typography variant='h6' >Continue</Typography>
                  </ButtonLoading>
                </Grid>
                <Grid item xs={12}>
                  <Box display={"flex"} >
                    <Link className="ml-2" href="/login"
                      onClick={(e) => {
                        e.preventDefault()
                        naviagte(history, "login")
                      }}>Back to Login</Link>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </CardContent>
        </Card>
      </Box>
    </Container >
  );
}
export default FormVerifyResetPassword
